import { Input, Select, Tabs, Typography, Form, Button, Alert, Card, Divider, Space } from "antd";
import React, { useContext, useState } from "react";
import { SimulatorContext } from "store/context";

const { Text } = Typography;

const VehicleDetails = ({ api, setLookDep, fetchJobDetails }) => {
  const { vehicleSimulatorSettings: { serialNo } } = useContext(SimulatorContext);
  const items = [
    {
      key: 'vehicle',
      label: 'Vehicle Details',
      children:
        <>
          <Select
            options={[{
              value: 'v3',
              label: 'OTA Deployment v3 - non AWS'
            }]}
            defaultValue={'OTA Deployment v3 - non AWS'}
            style={{ margin: '5% 0' }}
          />
          <Form.Item label={`Serial No`}>{serialNo}</Form.Item>
          <Form.Item>
            <Button type="primary" onClick={() => setLookDep(true)}>Get Pending Job Executions</Button>
          </Form.Item>
        </>,
    },
    {
      key: 'notifications',
      label: 'Notifications',
      children: <>
        {api.length === 0 && <Text style={{ textAlign: 'center', marginTop: '10%' }}>No Notifications</Text>}
        {api.map((n) => <Alert
          style={{ marginBottom: '5%' }}
          message={`${n?.title}`}
          description={n?.endpoint.slice(0, 50) + '...'}
          type={n.type}
        />)}
      </>,
    },
    {
      key: 'topics',
      label: 'MQTT Topics',
      children: <>
        <Card title="Listener Topics" style={{ marginBottom: '5%' }}>
          <Space direction="vertical">
            <Text strong>Pending Job Listeners</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/get/accepted`}</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/get/rejected`}</Text>
          </Space>
          <Divider />
          <Space direction="vertical">
            <Text strong>Job Details Listeners</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/accepted`}</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/rejected`}</Text>
          </Space>
          <Divider />
          <Space direction="vertical">
            <Text strong>Update Job Listeners</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/accepted`}</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/rejected`}</Text>
          </Space>
        </Card>
        <Card title="Publisher Topics">
          <Space direction="vertical">
            <Text strong>Publish Pending Job</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/get`}</Text>
          </Space>
          <Divider />
          <Space direction="vertical">
            <Text strong>Publish Job Details</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get`}</Text>
          </Space>
          <Divider />
          <Space direction="vertical">
            <Text strong>Publish Update Job</Text>
            <Text code>{`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update`}</Text>
          </Space>
          <Divider />
          <Space direction="vertical">
            <Text strong>Update Execution Signal</Text>
            <Text code>{`visteon/nextdev/jobs/${fetchJobDetails}`}</Text>
          </Space>
        </Card>
      </>,

    },
  ];

  return <>
    <Tabs defaultActiveKey="vehicle" items={items} />
  </>
}

export default VehicleDetails;